
export const testimonials = [
    {
        id: 1,
        name: "Emily R.",
        image: '../images/image-emily.jpg',
        desc: "We put our trust in Sunnyside and they delivered, making sure our needs were met and deadlines were always hit.",
        title: "Marketing Director",
    },
    {
        id: 2,
        name: "Thomas S.",
        image: '../images/image-thomas.jpg',
        desc: "Sunnyside's enthusiasm coupled with their keen interest in our brand's success made it a satisfying and enjoyable experience.",
        title: "Chief Operating Officer",
    },
    {
        id: 3,
        name: "Jennie F.",
        image: '../images/image-jennie.jpg',
        desc: "Incredible end result! Our Sales increased over 400% when we worked with Sunnyside. Highly recommended!",
        title: "Business Owner",
    },
]